import type { Router } from 'vue-router';
import NProgress from 'nprogress'; // progress bar

import { useUserStore } from '@/store';
import { goSSO, isLogin } from '@/utils/auth';
// import { DEFAULT_ROUTE_NAME } from '@/router/constants';
// import * as Sentry from '@sentry/vue';

export default function setupUserLoginInfoGuard(router: Router) {
  router.beforeEach(async (to, _from, next) => {
    NProgress.start();
    try {
      const userStore = useUserStore();
      if (self !== top) {
        // const account = localStorage.getItem('account');
        // Sentry.setUser({
        //   id: account + '老BI',
        //   username: account + '老BI'
        // });
        next();
      } else if (isLogin()) {
        try {
          await userStore.info();
          next();
        } catch (error) {
          await userStore.logout();
        }
      } else {
        goSSO();
      }
    } finally {
      NProgress.done();
    }
  });
}
